import React from "react";

export default function ProfileBar({ profile }) {
  return (
    <div style={{ textAlign: "right", fontSize: ".8rem", color: "#999" }}>
      {profile.usn.toUpperCase()}
    </div>
  );
}
